export const LOGO_URL = "/lfs-logo.png";
export const FLYER_URL = "/lfs-flyer.png";
export const BRAND = "Love Financial Solutions";
export const TAGLINE = "Credit Today • Opportunities Tomorrow";
export const SLOGAN = "A Stronger You. A Brighter Future.";

export const BUREAU_COLORS = {
  Equifax: { text: "text-red-700", border: "border-red-300", dot: "bg-red-500", chip: "bg-red-50" },
  Experian: { text: "text-blue-700", border: "border-blue-300", dot: "bg-blue-500", chip: "bg-blue-50" },
  TransUnion: { text: "text-cyan-700", border: "border-cyan-300", dot: "bg-cyan-500", chip: "bg-cyan-50" },
  Furnisher: { text: "text-amber-700", border: "border-amber-300", dot: "bg-amber-500", chip: "bg-amber-50" },
};

export const STATUS_COLORS = {
  "Drafted": "bg-stone-100 text-stone-700 border-stone-300",
  "Dispatched Certified": "bg-blue-50 text-blue-700 border-blue-200",
  "Under 4-Day Review": "bg-amber-50 text-amber-700 border-amber-200",
  "Under Bureau Review": "bg-amber-50 text-amber-700 border-amber-200",
  "Received by Bureau": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Additional Docs Requested": "bg-orange-50 text-orange-700 border-orange-200",
  "Blocked & Deleted": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Block Confirmed": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Resolved / Blocked": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Escalated to CFPB": "bg-rose-50 text-rose-700 border-rose-200",
};
